export const LOGIN_API = 'LOGIN_API';
export const LOGOUT_API = 'LOGOUT_API';